import { IcepackFilledCustomModalCell } from './components/icepack-filled-custom-modal-cell';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const ICEPACK_FORM_NAME = 'icepack-filled-form';

export const ICEPACK_FILLED_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: IcepackFilledCustomModalCell },
];

export const ICEPACK_FILLED_TABLE_ROWS_NAMES = {
	partner: 'Производитель',
	filler: 'Тип наполнителя',
	state: 'Состояние наполнителя',
	mode: 'Температурный режим',
	weight: 'Масса',
	author: 'Автор',
};

export const REQUIRED_FIELDS = ['icepack_id', 'filler_id', 'state_id', 'mode_id', 'weight'];

export const FIELDS_FOR_VALIDATE = ['icepack_id', 'filler_id', 'state_id', 'mode_id', 'weight'];
